export default __webpack_public_path__ + "static/media/3062.7d5fc797.jpg";